import { type ReactNode } from 'react';
import { FieldInput } from '@/components/ui/field-input';
import { SectionHeader } from '@/components/ui/section-header';
import { fieldChange } from '../utils/field-change';
import {
  ContactRow,
  LocationRow,
  NameRow,
  PhoneRow,
  type RowProps,
} from './new-member-rows';

export function PersonalSection(p: RowProps): ReactNode {
  return (
    <div className="space-y-sm">
      <SectionHeader label="Datos personales" />
      <NameRow {...p} />
      <ContactRow {...p} />
      <PhoneRow {...p} />
      <LocationRow {...p} />
      <FieldInput
        type="date"
        label="Fecha de nacimiento"
        value={p.data.birthdate}
        onChange={fieldChange(p.data, p.onChange, 'birthdate')}
        error={p.errors.birthdate}
      />
    </div>
  );
}
